import React from 'react';

interface StatCardProps {
  label: string;
  value: string | number;
  subtitle?: string;
  trend?: number;
  icon?: React.ReactNode;
}

export default function StatCard({ label, value, subtitle, trend, icon }: StatCardProps) {
  const trendColor = trend && trend > 0 ? 'text-green-400' : trend && trend < 0 ? 'text-red-400' : 'text-neutral-500';
  const trendSign = trend && trend > 0 ? '+' : '';

  return (
    <div className="bg-surface border border-border rounded-2xl p-5 backdrop-blur-sm bg-opacity-40">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs text-neutral-500 uppercase tracking-wider">{label}</span>
        {icon && <span className="text-neutral-600">{icon}</span>}
      </div>
      <div className="text-2xl font-bold text-white">{value}</div>
      <div className="flex items-center gap-2 mt-1">
        {trend !== undefined && (
          <span className={`text-sm font-medium ${trendColor}`}>
            {trendSign}{trend.toFixed(1)}%
          </span>
        )}
        {subtitle && <span className="text-xs text-neutral-500">{subtitle}</span>}
      </div>
    </div>
  );
}
